import type { IUser, IUpdateUser } from 'src/types/user';

import { client } from './ApiClient';

const BASE_PATH = '/api/v1';
const PARAM_REGEX = /{(\w+)}/g;

type PathParams = Record<string, string | number | undefined>;

type Nullable<T> = T | null | undefined;

function buildUrl(template: string, params?: Nullable<PathParams>) {
  if (!params) {
    return template;
  }

  return template.replace(PARAM_REGEX, (_, key: string) => {
    const value = params[key];
    if (value === undefined || value === null) {
      throw new Error(`Missing path parameter "${key}" for url ${template}`);
    }
    return encodeURIComponent(String(value));
  });
}

export async function fetchCurrentUser(): Promise<IUser> {
  const { data } = await client.get<{ user?: IUser }>(`${BASE_PATH}/users/current/`);
  if (data?.user) {
    return data.user;
  }
  return data as unknown as IUser;
}

export async function updateCurrentUser(payload: IUpdateUser): Promise<IUser> {
  const { data } = await client.post<{ user?: IUser }>(`${BASE_PATH}/users/current/`, payload);
  if (data?.user) {
    return data.user;
  }
  return data as unknown as IUser;
}

export async function fetchUser(userId: number): Promise<IUser> {
  const url = buildUrl(`${BASE_PATH}/users/{id}/`, { id: userId });
  const { data } = await client.get<{ user?: IUser } | IUser>(url);
  if ((data as { user?: IUser }).user) {
    return (data as { user: IUser }).user;
  }
  return data as IUser;
}

export async function updateUser(userId: number, payload: IUpdateUser): Promise<IUser> {
  const url = buildUrl(`${BASE_PATH}/users/{id}/`, { id: userId });
  const { data } = await client.put<{ user?: IUser } | IUser>(url, payload);
  if ((data as { user?: IUser }).user) {
    return (data as { user: IUser }).user;
  }
  return data as IUser;
}
